import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is medical software development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Medical software development involves developing, testing, deploying, and maintaining software solutions that support various healthcare processes, improve patient care, enhance operational efficiency, and facilitate medical research. Medical software development encompasses a wide range of applications and systems, including:</p>
                                    <ul>
                                        <li>Electronic Health Record (EHR) Systems</li>
                                        <li>Medical Imaging and Diagnostic Systems</li>
                                        <li>Telemedicine and Remote Patient Monitoring</li>
                                        <li>Medical Practice Management Systems</li>
                                        <li>Clinical Decision Support SystemsMedical Research and Data Analysis</li>
                                        <li>Health and Wellness Applications</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the healthcare development trends of 2023?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>Telemedicine and Remote Patient Monitoring</li>
                                        <li>Artificial Intelligence (AI) and Machine Learning (ML)</li>
                                        <li>Internet of Medical Things (IoMT)</li>
                                        <li>Blockchain in Healthcare</li>
                                        <li>Precision Medicine</li>
                                        <li>Virtual and Augmented Reality</li>
                                        <li>Data Analytics and Predictive Analytics</li>
                                        <li>Cybersecurity and Data Privacy</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                            <Accordion.Header>
                                What are TekRevol’s healthcare IoT development services?
                            </Accordion.Header>
                            <Accordion.Body>
                                <p>Our IoT healthcare development services include wearable devices, remote patient monitoring, and an IoT-based medical inventory tracker.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    Are your healthcare software development services aligned with HIPAA compliance standards?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, we implement the optimum quality and security assurance throughout the healthcare software development and follow best practices that comply with HIPAA standards.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>
                                    What is AI-enabled healthcare development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>AI-enabled healthcare development integrates artificial intelligence (AI) technologies into healthcare, including research and diagnostics. It uses machine learning algorithms to analyze healthcare data and assist healthcare professionals in decision-making.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>
                                    What is the difference between digital health and telemedicine?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Digital health involves the broader use of digital technologies in healthcare. At the same time, Telemedicine refers explicitly to the remote delivery of healthcare services using telecommunications technology, enabling remote consultations, diagnoses, and treatments.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;